export default __webpack_public_path__ + "static/12-ef80ad22e28375e9410623fdc51ea8db.png";